import { gql } from "generated-graphql";

export const DOCUMENT_AI_ENRICHMENT_JOB_STATUS = gql(`
  query DocumentAIEnrichmentJob($id: ID!) {
    documentAIEnrichmentJob(id: $id) {
      id
      status
      documents {
        id
        title
        originalTitle
        extractionStatus
        lastExtractionAt
        extractionError
      }
    }
  }
`);

export const SDS_PARSING_JOBS_STATUS = gql(`
  query SdsParsingJobs($tenantId: ID!, $ids: [ID!]!) {
    sdsParsingJobs(tenantId: $tenantId, ids: $ids) {
      id
      status
      stepError
      document {
        id
        title
      }
    }
  }
`);
